import { render, staticRenderFns } from "./HeaderFrame.vue?vue&type=template&id=7dbf802c&scoped=true"
import script from "./HeaderFrame.vue?vue&type=script&lang=js"
export * from "./HeaderFrame.vue?vue&type=script&lang=js"
import style0 from "./HeaderFrame.vue?vue&type=style&index=0&id=7dbf802c&prod&lang=sass&scoped=true"
import style1 from "./HeaderFrame.vue?vue&type=style&index=1&id=7dbf802c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf802c",
  null
  
)

export default component.exports